import type { Ref, SVGProps } from "react"
import { forwardRef, memo } from "react"

interface SVGRProps {
    title?: string
    titleId?: string
}
const SvgThreeDots = (
    { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
    ref: Ref<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 5 23"
        role="img"
        ref={ref}
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <circle cx={2.5} cy={2.5} r={2.5} fill="#fff" />
        <circle cx={2.5} cy={11.5} r={2.5} fill="#fff" />
        <circle cx={2.5} cy={20.5} r={2.5} fill="#fff" />
    </svg>
)
const ForwardRef = forwardRef(SvgThreeDots)
const Memo = memo(ForwardRef)
export default Memo
